import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum PathFilter {
    All
}

export enum PathOrder {
    None,
    RouteCode,
    StatusDescr,
    LegalTypeDescr,
    AdminAreaDescr,
    PriorityDescr
}
